import { render, staticRenderFns } from "./SettlementView.vue?vue&type=template&id=08f6eaab"
import script from "./SettlementView.vue?vue&type=script&lang=js"
export * from "./SettlementView.vue?vue&type=script&lang=js"
import style0 from "./SettlementView.vue?vue&type=style&index=0&id=08f6eaab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports